import { Controller } from "@hotwired/stimulus"

// Toggles the "upload document" vs "exemption" panels on the record-existing-
// waiver form based on the selected method radio. Inputs in the hidden panel are
// disabled so they don't submit (both panels share a `note` field).
export default class extends Controller {
  static targets = ["document", "exemption"]

  connect() {
    this.update()
  }

  update() {
    const method = this.element.querySelector('input[name="fulfillment_method"]:checked')?.value
    this.toggle(this.documentTarget, method === "uploaded_document")
    this.toggle(this.exemptionTarget, method === "exemption")
  }

  toggle(panel, show) {
    panel.hidden = !show
    panel.querySelectorAll("input, textarea, select").forEach((input) => {
      input.disabled = !show
    })
  }
}
